module.exports = __webpack_public_path__ + "static/gretel-43aead6b9aa0158e1e7351051df2af86.png";